import _ from 'lodash'
import axios from 'axios';

function composeGetter(parentKey, storeKeys, formatFn) {
  const result = {}

  for (let key of storeKeys) {
    result[`${parentKey}${_.upperFirst(key)}`] = state => {
      return formatPaginationData(
        _.get(state, `${parentKey}.${key}`, {}),
        parentKey,
        formatFn
      )
    }
  }

  return result
}

function formatPaginationData(data, parentKey, formatFn) {
  const totalPage = Math.ceil(data.total / data.limit)

  return {
    totalPage: totalPage || 1,
    total: data.total,
    [parentKey]: (data.data || []).map(item => {
      if (typeof formatFn === 'function') {
        return formatFn(item)
      }

      return item
    })
  }
}

function getAction(parentKey, endPoint, composeParams) {
  async function fetchData({ commit, state }, params = {}) {

    if (!params.storeKey) {
      throw new Error('storeKey is required')
    }

    const data = await axios.get(endPoint, {
      params: composeParams(state, params)
    })

    commit(`set${_.upperFirst(parentKey)}`, {
      data: data.data,
      storeKey: params.storeKey
    })
  }

  return { [`fetch${_.upperFirst(parentKey)}`]: fetchData }
}

export default function generatePaginationDataStore(
  parentKey,
  storeKeys,
  endPoint,
  composeParams,
  formatFn
) {
  return {
    getter: composeGetter(parentKey, storeKeys, formatFn),
    state: { [parentKey]: {} },
    action: getAction(parentKey, endPoint, composeParams),
    mutation: {
      [`set${_.upperFirst(parentKey)}`]: function(state, data) {
        state[parentKey][data.storeKey] = data.data
        state[parentKey] = { ...state[parentKey] }
      }
    }
  }
}
